import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
const TabelaDePrecoSubmit = ({ handleSubmit }) => {
  return (
    <button onClick={handleSubmit} className="button button send-button">
      Salvar
    </button>
  );
};

TabelaDePrecoSubmit.propTypes = {
  handleSubmit: PropTypes.func,
};

export default TabelaDePrecoSubmit;
